<template>
  <div class="track-card relative flex pointer cover bg-center bg-primary">
    <div class="flex-column w-100">
      <div class="track-info">
        <div class="body relative hide-child">
          <span
            class="white absolute top-0 v-mid w-100 h-100 child bg-black-40 flex items-center justify-center pointer">
            <div class="grow ba bw2 br-100 h3 w3 flex items-center justify-center" @click.prevent="playTrack()">
              <font-awesome-icon icon="play" size="2x"/>
            </div>
          </span>
          <img class="track-picture db" :src="picture" :alt="`${track.title} Picture`">
        </div>
        <p @click="playTrack()" class="pointer textColor f5 track-title ph2 mb1 b">{{ track.title }}</p>
        <router-link :to="{ name:'artist-info', params:{ id: track.artist.id }}" class="no-underline">
          <p class="accent pointer f6 mt0 track-title ph2 b">{{ track.artist.name }}</p>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
  import consts from '@/consts'

  export default {
    name: 'home-track-card',
    props: {
      track: {
        required: true
      }
    },
    components: {FontAwesomeIcon},
    computed: {
      picture () {
        if (this.track.picture) {
          if (!/\/uploads\/tracks\//.test(this.track.picture)) {
            return consts.MEDIA_BASE_URL + '/uploads/tracks/' + this.track.picture
          } else {
            return consts.MEDIA_BASE_URL + this.track.picture
          }
        } else {
          return '/static/assets/track.jpg'
        }
      }
    },
    methods: {
      playTrack () {
        this.$emit('playTrack', this.track)
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';

  a.track-info:link, a.artist-info:visited {
    color: #FFFFFF;
    text-decoration: none;
  }

  .track-card {
    width: 10rem;
    height: 14rem;
    flex-shrink: 0;
    flex-grow: 0;
    transition: all .6s;
  }

  .track-title {
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    white-space: nowrap;
  }

  .track-picture {
    line-height: 0;
    object-fit: cover;
    width: 100%;
  }

  .word-wrap {
    word-break: break-all;
  }

</style>



// WEBPACK FOOTER //
// src/components/home/HomeTrackCard.vue